import React, { Component, Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import moment from 'moment';
import dayjs from 'dayjs';
import axios from 'axios';
import { authService } from '../../services/authService';
import AdditionalForms from './additionalForms';

import { 
  Card, 
  Row, 
  Col, 
  Divider, 
  Form, 
  Input, 
  Select, 
  Radio,
  Button,
  Table,
  Space,
  TimePicker, 
  Spin
} from 'antd';

import { 
  PlusOutlined, 
  CloseOutlined, 
  BarcodeOutlined,
} from '@ant-design/icons';

import { 
  states, 
  dateMask, 
  isValidDob, 
  isValidZip, 
  isValidPhoneNumber,
  formatPhone,
  isValidCollectionD,
  GENERATE_INPUT_OBJECT,
} from '../utilities';

import DiagnosesModal from './DiagnosesModal'
import TestsModal from './TestsModal'
import TemplatesModal from './TemplatesModal'
import PatientModal from './PatientModal'
import RequisitionSubmitModal from './RequisitionSubmitModal'

import InputWithDropdown from '../elements/InputWithDropdown';
import { API_BASE_URL } from '../../config/api';


const { TextArea } = Input;

// Phlebotomist service codes auto-added for Homedraw order types. They are
// submitted and stored in connectTests like any other line, but they are not
// lab tests, so they don't satisfy the "at least one test" requirement.
const PHLEBOTOMY_SERVICE_TESTS = [
  { key: 'HV', code: 'HV', description: 'HOME VISIT' },
  { key: 'HD', code: 'HD', description: 'HOME DRAW' },
  { key: 'VEN', code: 'VEN', description: 'VENIPUNCTURE' },
];
const PHLEBOTOMY_SERVICE_CODES = PHLEBOTOMY_SERVICE_TESTS.map(t => t.code);
const isServiceCode = (code) => PHLEBOTOMY_SERVICE_CODES.includes(String(code || '').toUpperCase());

const styles = {
  root: {
    borderColor: '#2e6da4',
    boxShadow: '0 2px 8px #3177b4ff',
    borderRadius: 8,
  },
  extra: {
    color: '#2e6da4',
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    color: '#2e6da4',
  },
};

const newInsurance = (id = "", description = "", policy = "", groupID = "", isPrimary = false) => {
   return {
    id: GENERATE_INPUT_OBJECT(id),
    description: GENERATE_INPUT_OBJECT(description),
    policy: GENERATE_INPUT_OBJECT(policy),
    groupID: GENERATE_INPUT_OBJECT(groupID),
    isPrimary: isPrimary
  }
}

const mapInsurance = ({id, description, policy, groupID, isPrimary}) => {
  return {
    id:id.value,
    description:description.value,
    policy:policy.value,
    isPrimary,
    groupID: groupID.value
  }
}

class OrderEntry extends Component {
  constructor(props){
    super(props);
    this.additionalFormRefs = {};
    this.state = {
      id: props.requisitionID ? props.requisitionID:'',
      requisitionID: '',
      lastName: '',
      firstName: '',
      dob: '',
      gender: '',
      ethnicity: '',
      race: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      patientID: '',
      billTo: props.client.ClientCode === '5109'? 'Client':'',
      relationToInsured: '',
      insuranceList: [],
      insurances: [],
      insuredLastName: '',
      insuredFirstName: '',
      insuredDob: '',
      insuredAddress: '',
      insuredCity: '',
      insuredState: '',
      insuredZip: '',
      collectionDate: moment().format('MM/DD/YYYY'),
      collectionTime: dayjs(),
      currentDate: false,
      fastingStatus: 'u',
      clinicalInformation: '',
      comments: '',
      diagnoses: [],
      tests: [],
      physicians: [],
      physicianCode: '',
      clientCode: props.client.ClientCode,
      client: props.client,
      orderType: '',

      validationMessages: [],

      isValidPhysicianCode: '',
      isValidOrderType: '',

      isValidLastName: '',
      isValidFirstName: '',
      isValidGender: '',
      isValidRace: '',
      isValidEthnicity: '',
      isValidDob: '',
      isValidAddress: '',
      isValidCity: '',
      isValidState: '',
      isValidZip: '',
      isValidPhone: '',
      isValidPatientID: '',

      isValidBillTo: '',
      isValidRelationToInsured: '',
      isValidInsuredLastName: '',
      isValidInsuredFirstName: '',
      isValidInsuredDob: '',
      isValidInsuredAddress: '',
      isValidInsuredCity: '',
      isValidInsuredState: '',
      isValidInsuredZip: '',

      isValidCollectionDate: '',
      isValidCollectionTime: '',
      isValidFastingStatus: '',

      submitting: false,
      showSubmitModal: false,
    }
  }

  componentDidMount = () => {
    this.loadPhysicians();
    this.loadInsurances();
    if (this.props.requisitionID){
      this.loadData()
    }
  }

  loadData = async () => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/requisitions/order/${this.props.requisitionID}`,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      if (res.data.id){
        this.setState({
          id: res.data.id,
          requisitionID: res.data.requisitionID,
          lastName: res.data.lastName,
          firstName: res.data.firstName,
          dob: moment.utc(res.data.dob).format('MM/DD/YYYY'),
          gender: res.data.sex === 'F' ? 'female':'male',
          ethnicity: res.data.ethnicity,
          race: res.data.race,
          address: res.data.homeAddress,
          city: res.data.homeCity,
          state: res.data.homeState,
          zip: res.data.homeZip,
          phone: res.data.phone,
          email: res.data.email,
          patientID: res.data.chartNumber,
          billTo: res.data.billTo,
          relationToInsured: res.data.insurances && res.data.insurances.length ? res.data.insurances[0].relationToInsured:'',
          insurances: res.data.insurances && res.data.insurances.length ? res.data.insurances.map(item => newInsurance(item.insCode, item.insurance, item.memberID, item.groupID, Boolean(item.isPrimary))):[],

          collectionDate: moment(res.data.collectionDate).format('MM/DD/YYYY'),
          collectionTime: dayjs(res.data.collectionDate),

          currentDate: false,
          fastingStatus: res.data.isFasting ? 'f':'n',
          clinicalInformation: res.data.clinicalInformation,
          comments: res.data.comments,
          diagnoses: res.data.diagnoses,
          tests: res.data.tests,

          physicianCode: res.data.physicianCode,
          clientCode: res.data.clientCode,
          orderType: res.data.orderType,
        })
      }
    }).catch(err =>{
      console.log(err);
    })
  }

  loadPhysicians = async () => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    let params = {
      clientCode: this.state.clientCode
    }
    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/physicians/search`,
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      this.setState({
        physicians: res.data.physicians,
      })
    }).catch(err =>{
      console.log(err);
    })
  }

  loadInsurances = async () => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    let params = {
      clientCode: this.state.clientCode
    }
    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/insurances`,
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      this.setState({
        insuranceList: res.data.insurances,
      })
    }).catch(err =>{
      console.log(err);
    })
  }

  handleChange = (nameOrEvent, maybeValue) => {
    if (typeof nameOrEvent === "object" && nameOrEvent?.target) {
      // native inputs: <input>, <textarea>
      const { name, value } = nameOrEvent.target;
      if (name === 'dob' || name === 'insuredDob'){
        this.setState({ [name]: dateMask(value) });
      } else if (name === 'collectionDate'){
        this.setState({ [name]: dateMask(value) });
      } else if (name === 'phone'){
        this.setState({ [name]: formatPhone(value) });
      } else {
        this.setState({ [name]: value });
      }      
    } else {
      if (nameOrEvent === "billTo" && maybeValue === "Insurance"){
        const name = nameOrEvent;
        const value = maybeValue;
        this.setState({ [name]: value, insurances: [...this.state.insurances, newInsurance("", "", "", "", this.state.insurances.length === 0)] });
      } else if (nameOrEvent === "orderType"){
        const name = nameOrEvent;
        const value = maybeValue;
        const isHomedraw = value === "Homedraw" || value === "HomedrawStanding";
        this.setState(prev => {
          // Strip any existing service codes first so switching between
          // Homedraw types never duplicates them, and switching to a regular
          // order type removes them.
          const realTests = prev.tests.filter(test => !isServiceCode(test.code));
          return {
            [name]: value,
            tests: isHomedraw ? [...realTests, ...PHLEBOTOMY_SERVICE_TESTS.map(t => ({ ...t }))] : realTests,
          };
        });
      } else {
      // controlled components: <Select>, <TimePicker>, etc.
        const name = nameOrEvent;
        const value = maybeValue;
        this.setState({ [name]: value });
      }
    }
  };

  onBlur = (eventOrKey, maybeValue) => {
    let key;
    let inputValue;

    if (typeof eventOrKey === 'object' && eventOrKey?.target) {
      // native inputs: <input>, <textarea>
      key = eventOrKey.target.getAttribute('name');
      inputValue = eventOrKey.target.value;
    } else {
      // controlled components: <Select>, <TimePicker>, etc.
      key = eventOrKey;
      inputValue = this.state[key];
    }

    let validator;

    switch (key) {
      case 'orderType':
      case 'lastName':
      case 'firstName':
      case 'gender':
      case 'race':
      case 'ethnicity':
      case 'address':
      case 'city':
      case 'state':
      case 'relationToInsured':
      case 'billTo':
      case 'insuredLastName':
      case 'insuredFirstName':
      case 'insuredAddress':
      case 'insuredCity':
      case 'insuredState':
        validator = (value) => value.trim().length !== 0;
        break;
      case 'dob':
      case 'insuredDob':
        validator = (value) => isValidDob(value);
        break;
      case 'zip':
      case 'insuredZip':
        validator = (value) => isValidZip(value);
        break;
      case 'phone':
        validator = (value) => isValidPhoneNumber(value);
        break;
      case 'collectionDate':
        validator = (value) => isValidCollectionD(value);
        break;
      case 'collectionTime':
        validator = (value) => !!value;
        break;
      case 'fastingStatus': 
        validator = (value) => value.trim().length !== 0;
        break;
      default:
        validator = () => true;
    }

    const isValid = inputValue && validator(inputValue);
    const newValue = isValid ? '' : 'error';

    const validationKey = key.charAt(0).toUpperCase() + key.slice(1);
    this.setState({
      ['isValid' + validationKey]: newValue,
    });
  };

  onSelectInsurance = (insurance ,index) => {
    var newInsurances = [...this.state.insurances]
    newInsurances[index].name = {...newInsurances[index].name, value:insurance.description, isValid: true }
    newInsurances[index].id = {...newInsurances[index].id, value:insurance.code, isValid: true }
    this.setState({insurances: newInsurances})
  }

  onChangeInsurance = (key, value, index) => {
    var newInsurances = [...this.state.insurances]
    newInsurances[index][key].value = value.target.value
    this.setState({insurances: newInsurances})
  }

  onBlurInsurance = (key, value, index) => {
    if(!this.state.insurances[index][key].isValid){
      var newInsurances = [...this.state.insurances]
      if (this.state.insurances[index][key].value){
        newInsurances[index][key].isValid = true
      }      
      this.setState({insurances: newInsurances})
    }
  }
  
  handleAddDiagnosis = (record) => {
    this.setState(prev => {
      if (prev.diagnoses.some(item => item.code === record.code)) {
        return null;
      }
      const newDx = {
        key: record.code || String(prev.diagnoses.length + 1),
        code: record.code,
        description: record.description,
      };
      return { diagnoses: [...prev.diagnoses, newDx] };
    });
  };

  handleRemoveDiagnosis = (code) => {
    this.setState(prev => ({
      diagnoses: prev.diagnoses.filter(dx => dx.code !== code),
    }));
  };

  handleAddTest = (record) => {
  this.setState(prev => {
    if (prev.tests.some(item => item.code === record.code)) {
      return null;
    }
    const newTest = {
      key: record.code || String(prev.tests.length + 1),
      code: record.code,
      description: record.description,
    };
    const updatedTests = [...prev.tests, newTest];
    return { tests: this.mappingTests(updatedTests) };
  });
};

  handleRemoveTest = (code) => {
    this.setState(prev => ({
      tests: prev.tests.filter(test => test.code !== code),
    }));
  };

  // Applying a template OVERWRITES the selected diagnoses and tests.
  handleApplyTemplate = ({ tests = [], diagnoses = [] }) => {
    const newDiagnoses = diagnoses.map(dx => ({
      key: dx.code,
      code: dx.code,
      description: dx.description,
    }));
    const newTests = tests.map(t => ({
      key: t.code,
      code: t.code,
      description: t.description,
    }));
    this.setState({
      diagnoses: newDiagnoses,
      tests: this.mappingTests(newTests),
    });
  };

  onAddInsurance = () => {
    // First insurance added defaults to primary so a lone insurance is never "Secondary".
    this.setState({insurances: [...this.state.insurances, newInsurance("", "", "", "", this.state.insurances.length === 0)]})
  }

  onRemoveInsurance = (removeIndex) => {
    let newInsurances = this.state.insurances.filter((i, index) => index !== removeIndex);
    // If removing the primary left no primary, promote the first remaining one.
    if(newInsurances.length && !newInsurances.some(i => i.isPrimary)) newInsurances[0].isPrimary = true
    this.setState({insurances: newInsurances})
  }

  onChangePrimaryInsurance = (primaryIndex) => {
    this.setState(prev => ({
      insurances: prev.insurances.map((item, index) => ({
        ...item,
        isPrimary: index === primaryIndex,
      })),
    }));
  };

  onChangeCurrent = () => {
    this.setState({
      currentDate: !this.state.currentDate,
      collectionDate: moment().format('MM/DD/YYYY'),
      collectionTime: dayjs(),
    })
  }

  onSelectPatient = (record) => {
    let newState = {};
    let insurances = [];

    if (record.primaryInsID) {
      // connectPatients stores the relation as text ('self'/'spouse'/...);
      // legacy LIS records used '1'..'4'. Accept both.
      let relation = 'Self';
      switch (String(record.primaryInsRel || '').toLowerCase()){
        case '2':
        case 'spouse':
          relation = "Spouse";
          break;
        case '3':
        case 'child':
          relation = 'Child';
          break;
        case '4':
        case 'other':
          relation = 'Other';
          break;
        default:
          break;
      }
      insurances.push(newInsurance(record.primaryInsID, record.primaryInsName, record.primaryPolicy, record.primaryGroupID, true));
      newState.billTo = "Insurance";
      newState.relationToInsured = relation;
      newState.isValidRelationToInsured = "";
      newState.isValidBillTo = "";
    }

    if (record.secondInsID) {
      insurances.push(newInsurance(record.secondInsID, record.secondInsName, record.secondPolicy, record.secondGroupID, false));
    }

    newState.insurances = insurances;

    this.setState({
      lastName: record.lastName,
      firstName: record.firstName,
      dob: record.dob ? moment.utc(record.dob).format('MM/DD/YYYY') : '',
      // Patient records carry 'M'/'F'; the form select uses 'male'/'female'.
      gender: record.gender === 'F' ? 'female' : record.gender === 'M' ? 'male' : '',
      ethnicity: record.ethnicity,
      race: record.race,
      address: record.address,
      city: record.city,
      state: record.state,
      zip: record.zip,
      phone: record.phone,
      email: record.email,
      patientID: record.patientID,
      ...newState,
    })
  }

  submit = async () => {
    this.setState({submitting: true})
    let isValid = true;
    let formData = {};
    let newState = {};
    let tests = [];
    let validationMessages = [];
    console.log(this.state)

    formData['clientCode'] = this.state.clientCode;

    if (this.state.requisitionID){
      formData['requisitionID'] = this.state.requisitionID;
    }

    if (this.state.physicianCode) {
      formData['physicianCode'] = this.state.physicianCode;
      formData['physician'] = this.state.physicians.filter(item => parseInt(item.PhysicianCode === this.state.physicianCode))
    } else {
      console.log("Not valid physician")
      newState['isValidPhysicianCode'] = "error";
      validationMessages.push("Required: Physician")
      isValid = false;
    }

    if (this.state.lastName) {
      formData['lastName'] = this.state.lastName;
    } else {
      console.log("Not valid last name")
      newState['isValidLastName'] = "error";
      validationMessages.push("Required: Last Name")
      isValid = false;
    }

    if (this.state.firstName) {
      formData['firstName'] = this.state.firstName;
    } else {
      console.log("Not valid first name")
      newState['isValidFirstName'] = "error";
      validationMessages.push("Required: First Name")
      isValid = false;
    }

    if (this.state.gender) {
      formData['gender'] = this.state.gender;
    } else {
      console.log("Not valid gender")
      newState['isValidGender'] = "error";
      validationMessages.push("Required: Gender")
      isValid = false;
    } 

    if (this.state.race) {
      formData['race'] = this.state.race;
    } else {
      console.log("Not valid race")
      newState['isValidRace'] = "error";
      validationMessages.push("Required: Race")
      isValid = false;
    }

    if (this.state.ethnicity) {
      formData['ethnicity'] = this.state.ethnicity;
    } else {
      console.log("Not valid ethnicity")
      newState['isValidEthnicity'] = "error";
      validationMessages.push("Required: Ethnicity")
      isValid = false;
    }
    
    if (this.state.dob) {
      if(isValidDob(this.state.dob)){
        formData['dob'] = moment.utc(this.state.dob, 'MM/DD/YYYY').format('YYYY-MM-DD');
      } else {
        console.log("Not valid format dob")
        newState['isValidDob'] = "error";
        validationMessages.push("Invalid: Date of Birth")
        isValid = false;
      }
    } else {
      console.log("Not valid dob")
      newState['isValidDob'] = "error";
      validationMessages.push("Required: Date of Birth")
      isValid = false;
    }

    if (this.state.address) {
      formData['address'] = this.state.address;
    } else {
      console.log("Not valid address")
      newState['isValidAddress'] = "error";
      validationMessages.push("Required: Address")
      isValid = false;
    }

    if (this.state.city) {
      formData['city'] = this.state.city;
    } else {
      console.log("Not valid city")
      newState['isValidCity'] = "error";
      validationMessages.push("Required: City")
      isValid = false;
    }

    if (this.state.state) {
      formData['state'] = this.state.state;
    } else {
      console.log("Not valid state")
      newState['isValidState'] = "error";
      validationMessages.push("Required: State")
      isValid = false;
    }

    if (this.state.zip){
      if (isValidZip(this.state.zip)) {
        formData['zip'] = this.state.zip;
      } else {
        console.log("Not valid format zip")
        newState['isValidZip'] = "error";
        validationMessages.push("Invalid: Zip")
        isValid = false;        
      }
    } else {
      console.log("Not valid zip")
      newState['isValidZip'] = "error";
      validationMessages.push("Required: Zip")
      isValid = false;
    }

    if(this.state.phone){
      if (isValidPhoneNumber(this.state.phone)) {
        formData['phone'] = this.state.phone;
      } else {
        console.log("Not valid format phone")
        newState['isValidPhone'] = "error";
        validationMessages.push("Invalid: Phone Number")
        isValid = false;
      }
    } else {
      console.log("Not valid phone")
      newState['isValidPhone'] = "error";
      validationMessages.push("Required: Phone")
      isValid = false;
    }

    if(this.state.email){
      formData['email'] = this.state.email;
    }

    if (this.state.patientID) {
      formData['patientID'] = this.state.patientID;
    } 
    // else {
    //   console.log("Not valid patientID")
    //   newState['isValidPatientID'] = "error";
    //   validationMessages.push("Required: Patient ID")
    //   isValid = false;
    // }

    if (this.state.billTo){
      formData['billTo'] = this.state.billTo;
    } else {
      console.log("Not valid billto")
      newState['isValidBillTo'] = "error";
      validationMessages.push("Required: Bill To")
      isValid = false;
    }

    if (this.state.billTo === 'Insurance'){
      if (this.state.relationToInsured){
        formData['relationToInsured'] = this.state.relationToInsured;
      } else {
        newState['isValidRelationToInsured'] = "error";
        validationMessages.push("Required: Relation to Insured")
        isValid = false;
      }

      formData['insurances'] = [];
      newState['insurances'] = [];
      this.state.insurances.forEach((insurance, index) => {
        let isValidInsurance = true;
        let newInsuranceState = {...insurance}

        if(!insurance.id.value){
          newInsuranceState.id.isValid = false;
          isValidInsurance = false;
        }
        if(!insurance.policy.value){
          newInsuranceState.policy.isValid = false;
          isValidInsurance = false;
        }
        // if(!insurance.groupID.value){
        //   newInsuranceState.groupID.isValid = false;
        //   isValidInsurance = false;
        // }

        formData['insurances'].push(mapInsurance(insurance))
        newState['insurances'].push(newInsuranceState)
        if(!isValidInsurance){
          isValid = false
          validationMessages.push(`Information missing/invalid for insurance ${index+1} `)
        }
      })

      // Guarantee exactly one primary. Without this a requisition could be saved
      // with every insurance isPrimary=false, so the printed form showed them all
      // as "Secondary" with no primary. If none is flagged, the first is primary.
      if (formData['insurances'].length && !formData['insurances'].some(ins => ins.isPrimary)) {
        formData['insurances'][0].isPrimary = true;
        if (newState['insurances'][0]) newState['insurances'][0].isPrimary = true;
      }
    }

    if (this.state.relationToInsured && this.state.relationToInsured !== 'Self') {
      if (this.state.insuredFirstName) {
        formData['insuredFirstName'] = this.state.insuredFirstName;
      } else {
        newState['isValidInsuredFirstName'] = "error";
        validationMessages.push("Required: Insured First Name")
        isValid = false;
      }

      if (this.state.insuredLastName) {
        formData['insuredLastName'] = this.state.insuredLastName;
      } else {
        newState['isValidInsuredLastName'] = "error";
        validationMessages.push("Required: Insured Last Name")
        isValid = false;
      }

      if (this.state.insuredDob) {
        if(isValidDob(this.state.insuredDob)){
          formData['insuredDob'] = moment.utc(this.state.insuredDob, 'MM/DD/YYYY').format('YYYY-MM-DD');
        } else {
          newState['isValidInsuredDob'] = "error";
          validationMessages.push("Invalid: Insured Date of Birth")
          isValid = false;
        }
      } else {
        newState['isValidInsuredDob'] = "error";
        validationMessages.push("Required: Insured Date of Birth")
        isValid = false;
      }

      if (this.state.insuredAddress) {
        formData['insuredAddress'] = this.state.insuredAddress;
      } else {
        newState['isValidInsuredAddress'] = "error";
        validationMessages.push("Required: Insured Address")
        isValid = false;
      }

      if (this.state.insuredCity) {
        formData['insuredCity'] = this.state.insuredCity;
      } else {
        newState['isValidInsuredCity'] = "error";
        validationMessages.push("Required: Insured City")
        isValid = false;
      }

      if (this.state.insuredState) {
        formData['insuredState'] = this.state.insuredState;
      } else {
        newState['isValidInsuredState'] = "error";
        validationMessages.push("Required: Insured State")
        isValid = false;
      }

      if (this.state.insuredZip){
        if (isValidZip(this.state.insuredZip)) {
          formData['insuredZip'] = this.state.insuredZip;
        } else {
          newState['isValidInsuredZip'] = "error";
          validationMessages.push("Invalid: Insured Zip")
          isValid = false;        
        }
      } else {
        newState['isValidInsuredZip'] = "error";
        validationMessages.push("Required: Insured Zip")
        isValid = false;
      }
    }

    if (this.state.orderType){
      formData['orderType'] = this.state.orderType;
      console.log(this.state.orderType)
      if (this.state.orderType === 'Stat' || this.state.orderType === 'Routine'){
        if(this.state.collectionDate){
          console.log(this.state.collectionDate, this.state.collectionTime)
          if (isValidCollectionD(this.state.collectionDate)) {
            console.log("YES")
            formData['collectionDate'] = this.state.collectionDate;
            formData['collectionTime'] = this.state.collectionTime ? dayjs(this.state.collectionTime).format('HH:mm:ss'):'';
          } else {
            console.log("Not valid format collection")
          }
        } else {
          console.log("Not valid collectioDate")
          if(!this.state.collectionDate){
            newState['isValidCollectionDate'] = "error";
            validationMessages.push("Required: Collection Date")
          } else if(!isValidCollectionD(this.state.collectionDate)){
            newState['isValidCollectionDate'] = "error";
            validationMessages.push("Invalid: Collection Date")
          }
          if(!this.state.collectionTime){
            newState['isValidCollectionTime'] = "error";
            validationMessages.push("Required: Collection Time")
          }
          isValid = false;
        }

        if (this.state.fastingStatus){
          formData['fastingStatus'] = this.state.fastingStatus;
        } else {
          console.log("Not valid fasting")
          newState['isValidFastingStatus'] = "error";
          validationMessages.push("Required: Fasting Status")
          isValid = false;
        }
      }      

    } else {
      console.log("Not valid ordertype")
      newState['isValidOrderType'] = "error";
      validationMessages.push("Required: Order Type")
      isValid = false;
    }

    if (this.state.clinicalInformation){
      formData['clinicalInformation'] = this.state.clinicalInformation;
    }

    if (this.state.comments){
      formData['comments'] = this.state.comments;
    }

    // Previous: diagnoses were only sent when billTo !== 'Client', so
    // client-billed orders dropped them (no DG1 in the HL7). Kept for rollback.
    // if (this.state.billTo !== 'Client') {
    //   if (this.state.diagnoses.length){
    //     formData['diagnoses'] = this.state.diagnoses;
    //   } else {
    //     console.log("Not valid dx")
    //     validationMessages.push("Required: Diagnoses Codes")
    //     isValid = false;
    //   }
    // }

    // Always send selected diagnoses; they are only required when not billed to Client.
    if (this.state.diagnoses.length){
      formData['diagnoses'] = this.state.diagnoses;
    } else if (this.state.billTo !== 'Client') {
      console.log("Not valid dx")
      validationMessages.push("Required: Diagnoses Codes")
      isValid = false;
    }


    this.state.tests.forEach((test, index) => {
      const json = {};

      // (test.additionalFormNames || []).forEach((additionalFormName) => {
      //   const refKey = `${additionalFormName}-${test.code}`;
      //   const ref = this.additionalFormRefs[refKey];

      //   if (!ref) {
      //     validationMessages.push(`Missing form for: ${test.description}`);
      //     isValid = false;
      //     return;
      //   }

      //   const data = ref.submitState();

      //   if (!data) {
      //     validationMessages.push(`Check additional information for: ${test.description}`);
      //     isValid = false;
      //     return;
      //   }

      //   json[additionalFormName] = data;
      // });

      tests[index] = { ...test, json };
    });

    // HV/HD/VEN are phlebotomist codes, not lab tests: keep them in the
    // payload but require at least one real test alongside them.
    const hasRealTest = tests.some(test => !isServiceCode(test.code));
    if (hasRealTest){
      formData['tests'] = tests;
    } else {
      console.log("Not valid test")
      validationMessages.push("Required: Tests Codes")
      isValid = false;
    }


    console.log(formData)
    if (isValid){
      console.log("VALID")

      const token = await authService.ensureValidToken();
      if (!token) {
        console.error('Not authenticated');
        return;
      }      

      axios({
        method: this.props.requisitionID ? 'PUT':'POST',
        url: `${API_BASE_URL}/connect/requisitions/${this.props.requisitionID ? this.props.requisitionID:""}`,
        data: formData,
        headers: { Authorization: `Bearer ${token}` },
      }).then(res => {
        this.setState({
          showSubmitModal: true, 
          id: res.data.connectID,
          submitting: false
        })
      }).catch(error => {
        console.log(error)
      });

    } else {
      console.log("SOMETHING IS NOT VALID")
      this.setState({
        ...newState,
        validationMessages: validationMessages,
        submitting: false,
      })
    }    
  }

  onClose = () => {
    this.setState({
      showSubmitModal: false
    }, () => window.location.href = '/order-entry')
  }

  mappingTests = (tests) => {
    console.log(tests)
    return tests.map((test) => {

      test.additionalFormNames = [];

      let additionalFormName = this.mappingTest(test.code);

      if (additionalFormName) {
        if (test.additionalFormNames.indexOf(additionalFormName) === -1){
          test.additionalFormNames.push(additionalFormName);
        }
      }

      return test;
    })
  }

  mappingTest = (code) => {

    let additionalFormName;

    switch(code) {
      case 'BB':
      case 'DP':
      case 'GB':
      case 'ORP':
      case 'PB':
      case 'PP':
      case 'UP':
          additionalFormName = "Biopsy";
        break;
      case 'FISH':
          additionalFormName = "Fish";
        break;
      case 'BVG1':
      case 'BVG':
      case '5664':
      case 'L511':
      case 'L211':
      case 'AR069':
      case 'AR089':
      case 'UCULT':
      case 'TCULT':
      case 'GCULT':
      case 'L181':
      case 'AR522':
      case 'AR312':
      case 'A541':
      case '6463':
      case 'HSV':
      case 'LD230':
          additionalFormName = "SOURCE";
        break;
      case 'GYN':
      case 'L400':
      case 'L600':
      case 'GYRF':
          additionalFormName = "Gyn";
        break;
      case 'NGYN':
          additionalFormName = "Ngyn";
        break;
      case 'L124':
          additionalFormName = "HpvSelf";
        break;
      default:
        break;
    }
    return additionalFormName;
  }

  renderOrder(){
    return(
      <Card title="Requisition Information" size="small" styles={styles}>
        <Form>
          <Row>
            <Col span={12} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Ordering Physician" 
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                layout="vertical"
                required
                validateStatus={this.state.isValidPhysicianCode}>
                <Select 
                  size="small"
                  name="physicianCode"                  
                  value={this.state.physicianCode}
                  onChange={(value) => this.handleChange("physicianCode", value)}
                  onBlur={(value) => this.onBlur("physicianCode", value)}
                  options={this.state.physicians.map(item => ({
                    value: item.PhysicianCode,
                    label: item.FullName
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Order Type" 
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                layout="vertical"
                required
                validateStatus={this.state.isValidOrderType}>
                  <Select 
                    size="small"
                    name="orderType"
                    value={this.state.orderType}
                    onChange={(value) => this.handleChange("orderType", value)}
                    onBlur={(value) => this.onBlur("orderType", value)}
                    options={[
                      {value: 'Routine', label: 'Routine'},
                      {value: 'Stat', label: 'Stat'},
                      {value: 'Homedraw', label: 'Homedraw'},
                      {value: 'HomedrawStanding', label: 'Standing Homedraw'}
                    ]}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>      
    )
  }

  renderPatient(){
    return(
      <Card title="Patient Information" size="small" styles={styles}
        extra={<PatientModal client={this.props.client} onSelectPatient={this.onSelectPatient}/>}
      >
        <Form>
          <Row>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Last Name" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidLastName}>
                  <Input 
                    size="small"
                    name="lastName"
                    value={this.state.lastName}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item 
                label="First Name" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidFirstName}>
                  <Input 
                    size="small"
                    name="firstName"
                    value={this.state.firstName}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item 
                label="DOB" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidDob}>
                  <Input 
                    size="small"
                    name="dob"
                    placeholder="mm/dd/yyyy"
                    value={this.state.dob}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Gender" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidGender}>
                  <Select 
                    size="small"
                    name="gender"
                    value={this.state.gender}
                    onChange={(value) => this.handleChange("gender", value)}
                    onBlur={(value) => this.onBlur("gender", value)}
                    options={[
                      {value: 'female', label: 'Female'},
                      {value: 'male', label: 'Male'},
                    ]}/>
              </Form.Item>
            </Col>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Race" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidRace}>
                  <Select 
                    size="small"
                    name="race"
                    value={this.state.race}
                    onChange={(value) => this.handleChange("race", value)}
                    onBlur={(value) => this.onBlur("race", value)}
                    options={[
                      {value: 'AIAN', label: 'Americal Indian/Alaskan Native'},
                      {value: 'ASI', label: 'Asian'},
                      {value: 'BLKAA', label: 'Black or African American'},
                      {value: 'NHW', label: 'Native Hawaiian'},
                      {value: 'OPAC', label: 'Other Pacific Islander'},
                      {value: 'WHCA', label: 'White or Caucasian'},
                      {value: 'OTH', label: 'Other Race'},
                      {value: 'UNK', label: 'Unknown'},
                    ]}/>
              </Form.Item>
            </Col>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Ethnicity" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidEthnicity}>
                  <Select 
                    size="small"
                    name="ethnicity"
                    value={this.state.ethnicity}
                    onChange={(value) => this.handleChange("ethnicity", value)}
                    onBlur={(value) => this.onBlur("ethnicity", value)}
                    options={[
                      {value: 'HL', label: 'Hispanic or Latino'},
                      {value: 'NHL', label: 'Non-Hispanic or Non-Latino'},
                      {value: 'UNK', label: 'Unknown'},
                    ]}/>
              </Form.Item>
            </Col>
          </Row>
          
          <Row>
            <Col xs={24} md={14} style={{padding: "0 5px"}}>
              <Form.Item
                label="Address" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidAddress}>
                  <Input 
                    size="small"
                    name="address"
                    value={this.state.address}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={5} style={{padding: "0 5px"}}>
              <Form.Item
                label="City" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidCity}>
                  <Input 
                    size="small"
                    name="city"
                    value={this.state.city}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={5} style={{padding: "0 5px"}}>
              <Form.Item
                label="State"
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidState}>
                  <Select 
                    size="small"
                    name="state"
                    value={this.state.state}
                    onChange={(value) => this.handleChange("state", value)}
                    onBlur={(value) => this.onBlur("state", value)}
                    options={states.map(item => ({
                      value: item.abbreviation,
                      label: item.name
                    }))}
                  />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={4} style={{padding: "0 5px"}}>
              <Form.Item
                label="Zip" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidZip}>
                  <Input 
                    size="small"
                    name="zip"
                    value={this.state.zip}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={6} style={{padding: "0 5px"}}>
              <Form.Item
                label="Phone" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                required
                validateStatus={this.state.isValidPhone}>
                  <Input 
                    size="small"
                    name="phone"
                    value={this.state.phone}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={8} style={{padding: "0 5px"}}>
              <Form.Item
                label="Email" 
                layout="vertical"
                labelCol={{ style: { paddingBottom: 1 }}}
                style={{ marginBottom: 5 }}>
                  <Input 
                    size="small"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={6} style={{padding: "0 5px"}}>
              <Form.Item
                label="Patient ID" 
                layout="vertical"
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}>
                  <Input 
                    size="small"
                    name="patientID"
                    value={this.state.patientID}
                    onChange={this.handleChange}
                    onBlur={this.onBlur}
                  />
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </Card>      
    )
  }

  renderBilling(){
    return(
      <Card title="Billing Information" size="small" styles={styles}>
        <Form>

          <Row>
            <Col span={12} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Bill To" 
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                layout="vertical"
                required
                validateStatus={this.state.isValidBillTo}>
                <Select 
                  size="small"
                  name="billTo"
                  value={this.state.billTo}
                  onChange={(value) => this.handleChange("billTo", value)}
                  onBlur={(value) => this.onBlur("billTo", value)}
                  options={[
                    {value: 'Insurance', label: 'Insurance'},
                    {value: 'Client', label: 'Client'},
                    {value: 'Patient', label: 'Patient'},
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{padding: "0 5px"}}>
              {this.state.billTo === 'Insurance' ?
                <Form.Item 
                  label="Relation ot Insured" 
                  style={{ marginBottom: 5 }}
                  labelCol={{ style: { paddingBottom: 1 }}}
                  layout="vertical"
                  required
                  validateStatus={this.state.isValidRelationToInsured}>
                    <Select 
                      size="small"
                      name="relationToInsured"
                      value={this.state.relationToInsured}
                      onChange={(value) => this.handleChange("relationToInsured", value)}
                      onBlur={(value) => this.onBlur("relationToInsured", value)}
                      options={[
                        {value: 'Self', label: 'Self'},
                        {value: 'Spouse', label: 'Spouse'},
                        {value: 'Child', label: 'Child'},
                        {value: 'Parent', label: 'Parent'},
                        {value: 'Other', label: 'Other'}
                      ]}
                  />
                </Form.Item>:null
              }
            </Col>
          </Row>

          {this.state.billTo === 'Insurance' ? 
            <Fragment>
              {this.state.insurances.map((insurance, index) => 
                <Row key={index}>
                  <Col xs={24} md={12} lg={9} style={{padding: "0 5px"}}>
                    <Form.Item 
                      label="Insurance Name" 
                      layout="vertical"
                      style={{ marginBottom: 5 }}
                      labelCol={{ style: { paddingBottom: 1 }}}
                      required
                      validateStatus={insurance.id.isValid ? "":"error"}
                    >
                        <InputWithDropdown
                          listItems={this.state.insuranceList}
                          onSelectItem={(ins) => this.onSelectInsurance(ins, index)}
                          placeholder="Search insurance..."
                          value={insurance.description.value}
                          onChange={(val) => this.onChangeInsurance("description", { target: { value: val } }, index)}
                        />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={5} style={{padding: "0 5px"}}>
                    <Form.Item 
                      label="Member ID" 
                      layout="vertical"
                      style={{ marginBottom: 5 }}
                      labelCol={{ style: { paddingBottom: 1 }}}
                      required
                      validateStatus={insurance.policy.isValid ? "":"error"}
                    >
                        <Input 
                          size="small"
                          name="policy"
                          value={insurance.policy.value}
                          onChange={(value) => this.onChangeInsurance("policy", value, index)}
                          onBlur={(value) => this.onBlurInsurance("policy", value, index)}
                        />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={4} style={{padding: "0 5px"}}>
                    <Form.Item 
                      label="Group ID" 
                      layout="vertical"
                      style={{ marginBottom: 5 }}
                      labelCol={{ style: { paddingBottom: 1 }}}
                    >
                        <Input 
                          size="small"
                          name="groupID"
                          value={insurance.groupID.value}
                          onChange={(value) => this.onChangeInsurance("groupID", value, index)}
                          onBlur={(value) => this.onBlurInsurance("groupID", value, index)}
                        />
                    </Form.Item>
                  </Col>
                  <Col xs={12} md={6} lg={3} style={{padding: "0 5px"}}>
                    <Form.Item 
                      label="Primary" 
                      layout="vertical"
                      labelCol={{ style: { paddingBottom: 1 }}}
                      style={{ marginBottom: 5 }}>
                        <Radio 
                          name="isPrimary"
                          checked={insurance.isPrimary}
                          onChange={() => this.onChangePrimaryInsurance(index)}
                        ></Radio>
                    </Form.Item>
                  </Col>
                  {this.state.insurances.length > 1 ?
                    <Col xs={12} md={6} lg={3} style={{padding: "0 5px"}}>
                      <Form.Item 
                        label=" " 
                        layout="vertical"
                        labelCol={{ style: { paddingBottom: 1 }}}
                        style={{ marginBottom: 5 }}>
                          <Button 
                            size="small" 
                            type="primary" 
                            danger 
                            ghost
                            onClick={() => this.onRemoveInsurance(index)}
                          ><CloseOutlined/></Button>
                      </Form.Item>
                    </Col>:null
                  }
                </Row>
              )}
              
              <Row>
                <Col span={24} style={{padding: "0 5px"}}>
                  <Button 
                    type="dashed" 
                    size="small" 
                    block
                    onClick={this.onAddInsurance}
                  ><PlusOutlined /> Add Another Insurance</Button>
                </Col>
              </Row>
            </Fragment>:null            
          }
                    
          {this.state.relationToInsured && this.state.relationToInsured !== 'Self' ?
            <Fragment>
              <br/>
              <Row>                
                <Col xs={24} md={9} style={{padding: "0 5px"}}>            
                  <Form.Item 
                    label="Insured Last Name" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredLastName}>
                      <Input 
                        size="small"
                        name="insuredLastName"
                        value={this.state.insuredLastName}
                        onChange={this.handleChange}
                        onBlur={this.onBlur}
                      />
                  </Form.Item>
                </Col>
                <Col xs={24} md={9} style={{padding: "0 5px"}}>
                  <Form.Item 
                    label="Insured First Name" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredFirstName}>
                      <Input 
                        size="small"
                        name="insuredFirstName"
                        value={this.state.insuredFirstName}
                        onChange={this.handleChange}
                        onBlur={this.onBlur}
                      />
                  </Form.Item>
                </Col>
                <Col xs={24} md={6} style={{padding: "0 5px"}}>
                  <Form.Item 
                    label="DOB" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredDob}>
                      <Input 
                        size="small"
                        name="insuredDob"
                        placeholder="mm/dd/yyyy"
                        value={this.state.insuredDob}
                        onChange={this.handleChange}
                        onBlur={this.onBlur}
                      />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col xs={24} md={10} style={{padding: "0 5px"}}>
                  <Form.Item
                    label="Address" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredAddress}>
                      <Input 
                        size="small"
                        name="insuredAddress"
                        value={this.state.insuredAddress}
                        onChange={this.handleChange}
                        onBlur={this.onBlur}
                      />
                  </Form.Item>
                </Col>
                <Col xs={24} md={5} style={{padding: "0 5px"}}>
                  <Form.Item
                    label="City" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredCity}>
                      <Input 
                        size="small"
                        name="insuredCity"
                        value={this.state.insuredCity}
                        onChange={this.handleChange}
                        onBlur={this.onBlur}
                      />
                  </Form.Item>
                </Col>
                <Col xs={24} md={5} style={{padding: "0 5px"}}>
                  <Form.Item
                    label="State" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredState}>
                      <Select 
                        size="small"
                        name="insuredState"
                        value={this.state.insuredState}
                        onChange={(value) => this.handleChange("insuredState", value)}
                        onBlur={(value) => this.onBlur("insuredState", value)}
                        options={states.map(item => ({
                          value: item.abbreviation,
                          label: item.name
                        }))}
                      />
                  </Form.Item>
                </Col>
                <Col xs={24} md={4} style={{padding: "0 5px"}}>
                  <Form.Item
                    label="Zip" 
                    layout="vertical"
                    style={{ marginBottom: 5 }}
                    labelCol={{ style: { paddingBottom: 1 }}}
                    required
                    validateStatus={this.state.isValidInsuredZip}>
                      <Input 
                        size="small"
                        name="insuredZip"
                        value={this.state.insuredZip}
                        onChange={this.handleChange}
                        onBlur={this.onBlur}
                      />
                  </Form.Item>
                </Col>
              </Row>
            </Fragment>:null
          }
        </Form>
      </Card>
    )
  }

  renderClinical(){
    return(
      <Card title="Clinical Information" size="small" styles={styles}>
        <Form>
          {this.state.orderType !== 'Homedraw' && this.state.orderType !== 'HomedrawStanding' ?
            <Row>
              <Col xs={24} md={8} style={{padding: "0 5px"}}>
                <Form.Item 
                  label="Collection Date" 
                  style={{ marginBottom: 5 }}
                  labelCol={{ style: { paddingBottom: 1 }}}
                  layout="vertical"
                  required
                  validateStatus={this.state.isValidCollectionDate}>
                    <Input 
                      size="small"
                      name="collectionDate"
                      value={this.state.collectionDate}
                      onChange={this.handleChange}
                      onBlur={this.onBlur}
                    />
                </Form.Item>
              </Col>
              <Col xs={24} md={5} style={{padding: "0 5px"}}>
                <Form.Item 
                  label="Time" 
                  style={{ marginBottom: 5 }}
                  labelCol={{ style: { paddingBottom: 1 }}}
                  layout="vertical"
                  required
                  validateStatus={this.state.isValidCollectionTime}>
                    <TimePicker 
                      use12Hours 
                      format="h:mm a" 
                      size="small"
                      name="collectionTime"
                      value={this.state.collectionTime}
                      onChange={(time) => this.handleChange("collectionTime", time)} 
                      onBlur={(time) => this.onBlur("collectionTime", time)}
                    />
                </Form.Item>
              </Col>
              <Col xs={24} md={3} style={{padding: "0 5px"}}>
                <Form.Item 
                  label="Current" 
                  style={{ marginBottom: 5 }}
                  labelCol={{ style: { paddingBottom: 1 }}}
                  layout="vertical"
                  >
                    <Radio 
                      name="currentDate"
                      checked={this.state.currentDate}
                      onChange={() => this.onChangeCurrent()}
                    ></Radio>
                </Form.Item>
              </Col>
              <Col xs={24} md={8} style={{padding: "0 5px"}}>
                <Form.Item 
                  label="Fasting Status" 
                  style={{ marginBottom: 5 }}
                  labelCol={{ style: { paddingBottom: 1 }}}
                  layout="vertical"
                  required
                  validateStatus={this.state.isValidFastingStatus}>
                    <Select 
                      size="small"
                      name="fastingStatus"
                      value={this.state.fastingStatus}
                      onChange={(value) => this.handleChange("fastingStatus", value)}
                      onBlur={(value) => this.onBlur("fastingStatus", value)}
                      options={[
                        {value: 'f', label: 'Fasting'},
                        {value: 'n', label: 'Non-fasting'},
                        {value: 'u', label: 'Unknown'},
                      ]}
                    />
                </Form.Item>
              </Col>
            </Row>:null
          }

          <Row>
            <Col xs={24} md={12} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Clinical Information" 
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                layout="vertical">
                  <TextArea 
                    rows={2} 
                    name="clinicalInformation"
                    value={this.state.clinicalInformation}
                    onChange={this.handleChange}
                  />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} style={{padding: "0 5px"}}>
              <Form.Item 
                label="Comments" 
                style={{ marginBottom: 5 }}
                labelCol={{ style: { paddingBottom: 1 }}}
                layout="vertical">
                  <TextArea 
                    rows={2} 
                    name="comments"
                    value={this.state.comments}
                    onChange={this.handleChange}
                  />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    )
  }

  renderDiagnoses(){
    const columns = [
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Button
              danger
              size="small"
              onClick={() => this.handleRemoveDiagnosis(record.code)}
            >
              <CloseOutlined />
            </Button>
          </Space>
        ),
      },
    ];
    const data = this.state.diagnoses;
    return(
      <Card 
        title="Diagnoses Codes" 
        size="small" 
        styles={styles}
        // 👇 pass callback into modal
        extra={<DiagnosesModal client={this.props.client} onSelectDx={this.handleAddDiagnosis} handleRemoveDiagnosis={this.handleRemoveDiagnosis} selectedDiagnoses={this.state.diagnoses}/>}
      >
        <Row>
          <Col span={24} style={{padding: "0 5px"}}>
            <Table
              className="diagnosis-table"
              columns={columns}
              dataSource={data}
              size="small"
              rowKey="code"
            />
          </Col>            
        </Row>
      </Card>
    )
  }

  renderTests(){
    const columns = [
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Button
              danger
              size="small"
              onClick={() => this.handleRemoveTest(record.code)}
            >
              <CloseOutlined />
            </Button>
          </Space>
        ),
      },
    ];
    const dataTests = this.state.tests;
    return(
      <Card 
        title="Test Codes" 
        size="small" 
        styles={styles}
        extra={<TestsModal client={this.props.client} mappingTests={this.mappingTests} onSelectTest={this.handleAddTest} handleRemoveTest={this.handleRemoveTest} selectedTests={this.state.tests}/>}
      >
        <Row>
          <Col span={24} style={{padding: "0 5px"}}>
            <Table
              className="diagnosis-table"
              columns={columns}
              dataSource={dataTests}
              size="small"
              rowKey="code"
            />
          </Col>            
        </Row>
      </Card>
    )
  }

  renderAdditionalInfo() {
  return this.state.tests.flatMap((test) => {
    if (!test.additionalFormNames?.length) return [];

    return test.additionalFormNames.map((additionalFormName) => {
      let FormComponent;

      switch (additionalFormName) {
        case 'SOURCE':
          FormComponent = AdditionalForms.Source;
          break;
        default:
          return null;
      }

      const { key, ...testProps } = test;

      return (
        <Col key={`${additionalFormName}-${test.code}`} xs={24} lg={12} style={{ padding: "0 5px" }}>
          <Card
            title={`${additionalFormName} - ${test.description}`}
            size="small"
            styles={styles}
          >
            <Row>
              <Col span={24} style={{ padding: "0 5px" }}>
                <FormComponent
                  {...testProps}
                  ref={(el) => {
                    if (el) this.additionalFormRefs[`${additionalFormName}-${test.code}`] = el;
                    else delete this.additionalFormRefs[`${additionalFormName}-${test.code}`];
                  }}
                />
              </Col>
            </Row>
          </Card>
          <br />
        </Col>
      );
    });
  }).filter(Boolean);
}

  renderSubmit(){
    return(
      <Fragment>
        {this.state.validationMessages.length ?
          <Fragment>
            <h4 style={{color: 'red'}}>Please resolve the following:</h4>
            <ul style={{listStyle: "none"}}>
              {
                this.state.validationMessages.map((message, index) => {
                  return (<li style={{color: 'red', fontSize: "8pt"}} key={index}>{message}</li>)
                })
              }
            </ul>
          </Fragment>:null
        }
        <Button type="primary" style={{ marginLeft: 'auto' }} onClick={this.submit}>
          {this.state.submitting ? <Spin/> : 
          <div><BarcodeOutlined /> {this.props.requisitionID ? "Update Requisitions":"Submit Requisition"}</div>}
        </Button>
      </Fragment>
    )
  }

  render(){
    return(
      <Card title="Order Entry" styles={{ header:{ minHeight: 36, padding: '0 12px' }, body:{padding: 8} }}>
        <Row>
          <Col xs={24} lg={12} style={{padding: "0 5px"}}>
            {this.renderOrder()}
            <Divider size="small" style={{ borderColor: '#2e6da4' }} dashed/>
            {this.renderPatient()}
          </Col>
          <Col xs={24} lg={12} style={{padding: "0 5px"}}>
            {this.renderBilling()}
            <Divider size="small" style={{ borderColor: '#2e6da4' }} dashed/>
            {this.renderClinical()}
          </Col>
        </Row>
        <Divider size="small" style={{ borderColor: '#2e6da4' }} dashed/>
        <Row>
          <Col span={24} style={{padding: "0 5px 8px"}}>
            <Space>
              <span style={{ color: '#2e6da4', fontWeight: 500 }}>Order Templates</span>
              <TemplatesModal
                client={this.props.client}
                selectedTests={this.state.tests}
                selectedDiagnoses={this.state.diagnoses}
                onApplyTemplate={this.handleApplyTemplate}
              />
            </Space>
          </Col>
        </Row>
        <Row>
          <Col xs={24} lg={12} style={{padding: "0 5px"}}>
            {this.renderDiagnoses()}
          </Col>
          <Col xs={24} lg={12} style={{padding: "0 5px"}}>
            {this.renderTests()}
          </Col>
        </Row>
        <Divider size="small" style={{ borderColor: '#2e6da4' }} dashed/>
        <Row>
          {this.renderAdditionalInfo()}
        </Row> 
        <Row>
          <Col span={24}>
            {this.renderSubmit()}
          </Col>  
        </Row>
         {this.state.showSubmitModal && 
            <RequisitionSubmitModal 
              id={this.state.id}  
              printers={this.props.printers}
              onClose={this.onClose}
              showSubmitModal={this.state.showSubmitModal}
            /> 
          }       
      </Card>
    )
  }
}

export default function OrderEntryWrapper(props) {
  const { requisitionID } = useParams();
  const navigate = useNavigate();
  return <OrderEntry {...props} requisitionID={requisitionID} navigate={navigate} />;
}